import { render, staticRenderFns } from "./CompaniesHouseAutocomplete.vue?vue&type=template&id=48494a1b&lang=pug"
import script from "./CompaniesHouseAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CompaniesHouseAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports